webpackJsonp(["pages.projects.pipelines.show"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/dropdown_job_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__job_name_component_vue__ = __webpack_require__("./pipelines/components/graph/job_name_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__job_component_vue__ = __webpack_require__("./pipelines/components/graph/job_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");





/**
 * Renders the dropdown for the pipeline graph.
 *
 * The following object should be provided as `job`:
 *
 * {
 *   "id": 4256,
 *   "name": "test",
 *   "status": {
 *     "icon": "icon_status_success",
 *     "text": "passed",
 *     "label": "passed",
 *     "group": "success",
 *     "details_path": "/root/ci-mock/builds/4256",
 *     "action": {
 *       "icon": "retry",
 *       "title": "Retry",
 *       "path": "/root/ci-mock/builds/4256/retry",
 *       "method": "post"
 *     }
 *   }
 * }
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_2__vue_shared_directives_tooltip__["a" /* default */]
  },

  components: {
    jobComponent: __WEBPACK_IMPORTED_MODULE_1__job_component_vue__["a" /* default */],
    jobNameComponent: __WEBPACK_IMPORTED_MODULE_0__job_name_component_vue__["a" /* default */]
  },

  props: {
    job: {
      type: Object,
      required: true
    }
  },

  computed: {
    tooltipText: function tooltipText() {
      return this.job.name + ' - ' + this.job.status.label;
    }
  },

  mounted: function mounted() {
    this.stopDropdownClickPropagation();
  },


  methods: {
    /**
    * When the user right clicks or cmd/ctrl + click in the job name
    * the dropdown should not be closed and the link should open in another tab,
    * so we stop propagation of the click event inside the dropdown.
    *
    * Since this component is rendered multiple times per page we need to guarantee we only
    * target the click event of this component.
    */
    stopDropdownClickPropagation: function stopDropdownClickPropagation() {
      $(this.$el.querySelectorAll('.js-grouped-pipeline-dropdown a.mini-pipeline-graph-dropdown-item')).on('click', function (e) {
        e.stopPropagation();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./lib/utils/bootstrap_linked_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Linked Tabs
 *
 * Handles persisting and restores the current tab selection and content.
 * Reusable component for static content.
 *
 * ### Example Markup
 *
 *  <ul class="nav-links tab-links">
 *    <li class="active">
 *      <a data-action="tab1" data-target="#tab1" data-toggle="tab" href="/path/tab1">
 *        Tab 1
 *      </a>
 *    </li>
 *    <li class="groups-tab">
 *      <a data-action="tab2" data-target="#tab2" data-toggle="tab" href="/path/tab2">
 *        Tab 2
 *      </a>
 *    </li>
 *
 *
 *  <div class="tab-content">
 *    <div class="tab-pane" id="tab1">
 *      Tab 1 Content
 *    </div>
 *    <div class="tab-pane" id="tab2">
 *      Tab 2 Content
 *    </div>
 * </div>
 *
 *
 * ### How to use
 *
 *  new LinkedTabs({
 *    action: "#{controller.action_name}",
 *    defaultAction: 'tab1',
 *    parentEl: '.tab-links'
 *  });
 */

var LinkedTabs = function () {
  /**
   * Binds the events and activates de default tab.
   *
   * @param  {Object} options
   */
  function LinkedTabs() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LinkedTabs);

    this.options = options;

    this.defaultAction = this.options.defaultAction;
    this.action = this.options.action || this.defaultAction;

    if (this.action === 'show') {
      this.action = this.defaultAction;
    }

    this.currentLocation = window.location;

    var tabSelector = this.options.parentEl + ' a[data-toggle="tab"]';

    // since this is a custom event we need jQuery :(
    $(document).off('shown.bs.tab', tabSelector).on('shown.bs.tab', tabSelector, function (e) {
      return _this.tabShown(e);
    });

    this.activateTab(this.action);
  }

  /**
   * Handles the `shown.bs.tab` event to set the currect url action.
   *
   * @param  {type} evt
   * @return {Function}
   */


  _createClass(LinkedTabs, [{
    key: 'tabShown',
    value: function tabShown(evt) {
      var source = evt.target.getAttribute('href');

      return this.setCurrentAction(source);
    }

    /**
     * Updates the URL with the path that matched the given action.
     *
     * @param  {String} source
     * @return {String}
     */

  }, {
    key: 'setCurrentAction',
    value: function setCurrentAction(source) {
      var copySource = source;

      copySource.replace(/\/+$/, '');

      var newState = '' + copySource + this.currentLocation.search + this.currentLocation.hash;

      history.replaceState({
        url: newState
      }, document.title, newState);
      return newState;
    }

    /**
     * Given the current action activates the correct tab.
     * http://getbootstrap.com/javascript/#tab-show
     * Note: Will trigger `shown.bs.tab`
     */

  }, {
    key: 'activateTab',
    value: function activateTab() {
      return $(this.options.parentEl + ' a[data-action=\'' + this.action + '\']').tab('show');
    }
  }]);

  return LinkedTabs;
}();

/* harmony default export */ __webpack_exports__["a"] = (LinkedTabs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400
});

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["x" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./pages/projects/pipelines/init_pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./lib/utils/bootstrap_linked_tabs.js
var bootstrap_linked_tabs = __webpack_require__("./lib/utils/bootstrap_linked_tabs.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: ./pipelines.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var pipelines_Pipelines = function Pipelines() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Pipelines);

  if (options.initTabs && options.tabsOptions) {
    // eslint-disable-next-line no-new
    new bootstrap_linked_tabs["a" /* default */](options.tabsOptions);
  }

  if (options.pipelineStatusUrl) {
    Object(common_utils["E" /* setCiStatusFavicon */])(options.pipelineStatusUrl);
  }
};

/* harmony default export */ var pipelines = (pipelines_Pipelines);
// CONCATENATED MODULE: ./pages/projects/pipelines/init_pipelines.js


/* harmony default export */ var init_pipelines = __webpack_exports__["a"] = (function () {
  var controllerAction = document.querySelector('.js-pipeline-container').dataset.controllerAction;

  var pipelineStatusUrl = document.querySelector('.js-pipeline-tab-link a').getAttribute('href') + '/status.json';

  new pipelines({ // eslint-disable-line no-new
    initTabs: true,
    pipelineStatusUrl: pipelineStatusUrl,
    tabsOptions: {
      action: controllerAction,
      defaultAction: 'pipelines',
      parentEl: '.pipelines-tabs'
    }
  });
});

/***/ }),

/***/ "./pages/projects/pipelines/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipelines_pipeline_details_bundle__ = __webpack_require__("./pipelines/pipeline_details_bundle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init_pipelines__ = __webpack_require__("./pages/projects/pipelines/init_pipelines.js");



document.addEventListener('DOMContentLoaded', function () {
  Object(__WEBPACK_IMPORTED_MODULE_1__init_pipelines__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_0__pipelines_pipeline_details_bundle__["a" /* default */])();
});

/***/ }),

/***/ "./pipelines/components/graph/job_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./lib/utils/text_utility.js
var text_utility = __webpack_require__("./lib/utils/text_utility.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/action_component.vue




/**
 * Renders either a cancel, retry or play icon pointing to the given path.
 * TODO: Remove UJS from here and use an async request instead.
 */
/* harmony default export */ var action_component = ({
  components: {
    icon: icon["a" /* default */]
  },

  directives: {
    tooltip: tooltip["a" /* default */]
  },

  props: {
    tooltipText: {
      type: String,
      required: true
    },

    link: {
      type: String,
      required: true
    },

    actionMethod: {
      type: String,
      required: true
    },

    actionIcon: {
      type: String,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var actionIconDash = Object(text_utility["d" /* dasherize */])(this.actionIcon);
      return actionIconDash + ' js-icon-' + actionIconDash;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bdefc0a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/action_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ci-action-icon-container ci-action-icon-wrapper",class:_vm.cssClass,attrs:{"data-method":_vm.actionMethod,"title":_vm.tooltipText,"href":_vm.link,"data-container":"body"}},[_c('icon',{attrs:{"name":_vm.actionIcon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/graph/action_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  action_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var graph_action_component = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/dropdown_action_component.vue




/**
 * Renders either a cancel, retry or play icon pointing to the given path.
 * TODO: Remove UJS from here and use an async request instead.
 */
/* harmony default export */ var dropdown_action_component = ({
  components: {
    icon: icon["a" /* default */]
  },

  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    tooltipText: {
      type: String,
      required: true
    },

    link: {
      type: String,
      required: true
    },

    actionMethod: {
      type: String,
      required: true
    },

    actionIcon: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c8772c4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/dropdown_action_component.vue
var dropdown_action_component_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ci-action-icon-wrapper js-ci-status-icon",attrs:{"data-method":_vm.actionMethod,"title":_vm.tooltipText,"href":_vm.link,"rel":"nofollow","data-container":"body","aria-label":"Job's action"}},[_c('icon',{attrs:{"name":_vm.actionIcon}})],1)}
var dropdown_action_component_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/graph/dropdown_action_component.vue
/* script */


/* template */

/* template functional */
var dropdown_action_component___vue_template_functional__ = false
/* styles */
var dropdown_action_component___vue_styles__ = null
/* scopeId */
var dropdown_action_component___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dropdown_action_component___vue_module_identifier__ = null

var dropdown_action_component_Component = Object(component_normalizer["a" /* default */])(
  dropdown_action_component,
  dropdown_action_component_render,
  dropdown_action_component_staticRenderFns,
  dropdown_action_component___vue_template_functional__,
  dropdown_action_component___vue_styles__,
  dropdown_action_component___vue_scopeId__,
  dropdown_action_component___vue_module_identifier__
)

/* harmony default export */ var graph_dropdown_action_component = (dropdown_action_component_Component.exports);

// EXTERNAL MODULE: ./pipelines/components/graph/job_name_component.vue + 2 modules
var job_name_component = __webpack_require__("./pipelines/components/graph/job_name_component.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/job_component.vue






/**
 * Renders the badge for the pipeline graph and the job's dropdown.
 *
 * The following object should be provided as `job`:
 *
 * {
 *   "id": 4256,
 *   "name": "test",
 *   "status": {
 *     "icon": "icon_status_success",
 *     "text": "passed",
 *     "label": "passed",
 *     "group": "success",
 *     "details_path": "/root/ci-mock/builds/4256",
 *     "action": {
 *       "icon": "retry",
 *       "title": "Retry",
 *       "path": "/root/ci-mock/builds/4256/retry",
 *       "method": "post"
 *     }
 *   }
 * }
 */

/* harmony default export */ var job_component = ({
  components: {
    actionComponent: graph_action_component,
    dropdownActionComponent: graph_dropdown_action_component,
    jobNameComponent: job_name_component["a" /* default */]
  },

  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    job: {
      type: Object,
      required: true
    },

    cssClassJobName: {
      type: String,
      required: false,
      default: ''
    },

    isDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    status: function status() {
      return this.job && this.job.status ? this.job.status : {};
    },
    tooltipText: function tooltipText() {
      var textBuilder = [];

      if (this.job.name) {
        textBuilder.push(this.job.name);
      }

      if (this.job.name && this.status.label) {
        textBuilder.push('-');
      }

      if (this.status.label) {
        textBuilder.push('' + this.job.status.label);
      }

      return textBuilder.join(' ');
    },


    /**
     * Verifies if the provided job has an action path
     *
     * @return {Boolean}
     */
    hasAction: function hasAction() {
      return this.job.status && this.job.status.action && this.job.status.action.path;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00bc666d","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/job_component.vue
var job_component_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-job-component"},[(_vm.status.has_details)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-graph-job-link",class:_vm.cssClassJobName,attrs:{"href":_vm.status.details_path,"title":_vm.tooltipText,"data-container":"body"}},[_c('job-name-component',{attrs:{"name":_vm.job.name,"status":_vm.job.status}})],1):_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-job-component-tooltip",class:_vm.cssClassJobName,attrs:{"title":_vm.tooltipText,"data-container":"body"}},[_c('job-name-component',{attrs:{"name":_vm.job.name,"status":_vm.job.status}})],1),_vm._v(" "),(_vm.hasAction && !_vm.isDropdown)?_c('action-component',{attrs:{"tooltip-text":_vm.status.action.title,"link":_vm.status.action.path,"action-icon":_vm.status.action.icon,"action-method":_vm.status.action.method}}):_vm._e(),_vm._v(" "),(_vm.hasAction && _vm.isDropdown)?_c('dropdown-action-component',{attrs:{"tooltip-text":_vm.status.action.title,"link":_vm.status.action.path,"action-icon":_vm.status.action.icon,"action-method":_vm.status.action.method}}):_vm._e()],1)}
var job_component_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/graph/job_component.vue
/* script */


/* template */

/* template functional */
var job_component___vue_template_functional__ = false
/* styles */
var job_component___vue_styles__ = null
/* scopeId */
var job_component___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var job_component___vue_module_identifier__ = null

var job_component_Component = Object(component_normalizer["a" /* default */])(
  job_component,
  job_component_render,
  job_component_staticRenderFns,
  job_component___vue_template_functional__,
  job_component___vue_styles__,
  job_component___vue_scopeId__,
  job_component___vue_module_identifier__
)

/* harmony default export */ var graph_job_component = __webpack_exports__["a"] = (job_component_Component.exports);


/***/ }),

/***/ "./pipelines/components/graph/job_name_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/job_name_component.vue



/**
 * Component that renders both the CI icon status and the job name.
 * Used in
 *  - Badge component
 *  - Dropdown badge components
 */
/* harmony default export */ var job_name_component = ({
  components: {
    ciIcon: ci_icon["a" /* default */]
  },
  props: {
    name: {
      type: String,
      required: true
    },

    status: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4bb600e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/job_name_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ci-job-name-component"},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),_c('span',{staticClass:"ci-status-text"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/graph/job_name_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  job_name_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var graph_job_name_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./pipelines/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./pipelines/pipeline_details_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// CONCATENATED MODULE: ./pipelines/stores/pipeline_store.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PipelineStore = function () {
  function PipelineStore() {
    _classCallCheck(this, PipelineStore);

    this.state = {};

    this.state.pipeline = {};
  }

  _createClass(PipelineStore, [{
    key: "storePipeline",
    value: function storePipeline() {
      var pipeline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.pipeline = pipeline;
    }
  }]);

  return PipelineStore;
}();

/* harmony default export */ var pipeline_store = (PipelineStore);
// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");

// CONCATENATED MODULE: ./pipelines/services/pipeline_service.js
var pipeline_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function pipeline_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

var pipeline_service_PipelineService = function () {
  function PipelineService(endpoint) {
    pipeline_service__classCallCheck(this, PipelineService);

    this.pipeline = vue_esm["a" /* default */].resource(endpoint);
  }

  pipeline_service__createClass(PipelineService, [{
    key: 'getPipeline',
    value: function getPipeline() {
      return this.pipeline.get();
    }

    // eslint-disable-next-line

  }, {
    key: 'postAction',
    value: function postAction(endpoint) {
      return vue_esm["a" /* default */].http.post(endpoint + '.json');
    }
  }]);

  return PipelineService;
}();

/* harmony default export */ var pipeline_service = (pipeline_service_PipelineService);
// CONCATENATED MODULE: ./pipelines/pipeline_details_mediator.js
var pipeline_details_mediator__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function pipeline_details_mediator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var pipeline_details_mediator_pipelinesMediator = function () {
  function pipelinesMediator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    pipeline_details_mediator__classCallCheck(this, pipelinesMediator);

    this.options = options;
    this.store = new pipeline_store();
    this.service = new pipeline_service(options.endpoint);

    this.state = {};
    this.state.isLoading = false;
  }

  pipeline_details_mediator__createClass(pipelinesMediator, [{
    key: 'fetchPipeline',
    value: function fetchPipeline() {
      var _this = this;

      this.poll = new poll["a" /* default */]({
        resource: this.service,
        method: 'getPipeline',
        successCallback: this.successCallback.bind(this),
        errorCallback: this.errorCallback.bind(this)
      });

      if (!visibilityjs_default.a.hidden()) {
        this.state.isLoading = true;
        this.poll.makeRequest();
      } else {
        this.refreshPipeline();
      }

      visibilityjs_default.a.change(function () {
        if (!visibilityjs_default.a.hidden()) {
          _this.poll.restart();
        } else {
          _this.poll.stop();
        }
      });
    }
  }, {
    key: 'successCallback',
    value: function successCallback(response) {
      var _this2 = this;

      return response.json().then(function (data) {
        _this2.state.isLoading = false;
        _this2.store.storePipeline(data);
      });
    }
  }, {
    key: 'errorCallback',
    value: function errorCallback() {
      this.state.isLoading = false;
      Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while fetching the pipeline.'));
    }
  }, {
    key: 'refreshPipeline',
    value: function refreshPipeline() {
      var _this3 = this;

      this.service.getPipeline().then(function (response) {
        return _this3.successCallback(response);
      }).catch(function () {
        return _this3.errorCallback();
      });
    }
  }]);

  return pipelinesMediator;
}();

/* harmony default export */ var pipeline_details_mediator = (pipeline_details_mediator_pipelinesMediator);
// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./pipelines/components/graph/job_component.vue + 8 modules
var job_component = __webpack_require__("./pipelines/components/graph/job_component.vue");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/dropdown_job_component.vue
var dropdown_job_component = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/dropdown_job_component.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b331cb94","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/dropdown_job_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-job-dropdown-container"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-menu-toggle build-content",attrs:{"type":"button","data-toggle":"dropdown","data-container":"body","title":_vm.tooltipText}},[_c('job-name-component',{attrs:{"name":_vm.job.name,"status":_vm.job.status}}),_vm._v(" "),_c('span',{staticClass:"dropdown-counter-badge"},[_vm._v("\n      "+_vm._s(_vm.job.size)+"\n    ")])],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu big-pipeline-graph-dropdown-menu js-grouped-pipeline-dropdown"},[_c('li',{staticClass:"scrollable-menu"},[_c('ul',_vm._l((_vm.job.jobs),function(item,i){return _c('li',{key:i},[_c('job-component',{attrs:{"job":item,"is-dropdown":true,"css-class-job-name":"mini-pipeline-graph-dropdown-item"}})],1)}))])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/graph/dropdown_job_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  dropdown_job_component["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var graph_dropdown_job_component = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/stage_column_component.vue




/* harmony default export */ var stage_column_component = ({
  components: {
    jobComponent: job_component["a" /* default */],
    dropdownJobComponent: graph_dropdown_job_component
  },
  props: {
    title: {
      type: String,
      required: true
    },

    jobs: {
      type: Array,
      required: true
    },

    isFirstColumn: {
      type: Boolean,
      required: false,
      default: false
    },

    stageConnectorClass: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {
    firstJob: function firstJob(list) {
      return list[0];
    },
    jobId: function jobId(job) {
      return 'ci-badge-' + job.name;
    },
    buildConnnectorClass: function buildConnnectorClass(index) {
      return index === 0 && !this.isFirstColumn ? 'left-connector' : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9d90a9e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/stage_column_component.vue
var stage_column_component_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"stage-column",class:_vm.stageConnectorClass},[_c('div',{staticClass:"stage-name"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"builds-container"},[_c('ul',_vm._l((_vm.jobs),function(job,index){return _c('li',{key:job.id,staticClass:"build",class:_vm.buildConnnectorClass(index),attrs:{"id":_vm.jobId(job)}},[_c('div',{staticClass:"curve"}),_vm._v(" "),(job.size === 1)?_c('job-component',{attrs:{"job":job,"css-class-job-name":"build-content"}}):_vm._e(),_vm._v(" "),(job.size > 1)?_c('dropdown-job-component',{attrs:{"job":job}}):_vm._e()],1)}))])])}
var stage_column_component_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/graph/stage_column_component.vue
/* script */


/* template */

/* template functional */
var stage_column_component___vue_template_functional__ = false
/* styles */
var stage_column_component___vue_styles__ = null
/* scopeId */
var stage_column_component___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var stage_column_component___vue_module_identifier__ = null

var stage_column_component_Component = Object(component_normalizer["a" /* default */])(
  stage_column_component,
  stage_column_component_render,
  stage_column_component_staticRenderFns,
  stage_column_component___vue_template_functional__,
  stage_column_component___vue_styles__,
  stage_column_component___vue_scopeId__,
  stage_column_component___vue_module_identifier__
)

/* harmony default export */ var graph_stage_column_component = (stage_column_component_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/graph/graph_component.vue




/* harmony default export */ var graph_component = ({
  components: {
    stageColumnComponent: graph_stage_column_component,
    loadingIcon: loading_icon["a" /* default */]
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    pipeline: {
      type: Object,
      required: true
    }
  },

  computed: {
    graph: function graph() {
      return this.pipeline.details && this.pipeline.details.stages;
    }
  },

  methods: {
    capitalizeStageName: function capitalizeStageName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    isFirstColumn: function isFirstColumn(index) {
      return index === 0;
    },
    stageConnectorClass: function stageConnectorClass(index, stage) {
      var className = void 0;

      // If it's the first stage column and only has one job
      if (index === 0 && stage.groups.length === 1) {
        className = 'no-margin';
      } else if (index > 0) {
        // If it is not the first column
        className = 'left-margin';
      }

      return className;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6318b99e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/graph_component.vue
var graph_component_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"build-content middle-block js-pipeline-graph"},[_c('div',{staticClass:"pipeline-visualization pipeline-graph pipeline-tab-content"},[_c('div',{staticClass:"text-center"},[(_vm.isLoading)?_c('loading-icon',{attrs:{"size":"3"}}):_vm._e()],1),_vm._v(" "),(!_vm.isLoading)?_c('ul',{staticClass:"stage-column-list"},_vm._l((_vm.graph),function(stage,index){return _c('stage-column-component',{key:stage.name,attrs:{"title":_vm.capitalizeStageName(stage.name),"jobs":stage.groups,"stage-connector-class":_vm.stageConnectorClass(index, stage),"is-first-column":_vm.isFirstColumn(index)}})})):_vm._e()])])}
var graph_component_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/graph/graph_component.vue
/* script */


/* template */

/* template functional */
var graph_component___vue_template_functional__ = false
/* styles */
var graph_component___vue_styles__ = null
/* scopeId */
var graph_component___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var graph_component___vue_module_identifier__ = null

var graph_component_Component = Object(component_normalizer["a" /* default */])(
  graph_component,
  graph_component_render,
  graph_component_staticRenderFns,
  graph_component___vue_template_functional__,
  graph_component___vue_styles__,
  graph_component___vue_scopeId__,
  graph_component___vue_module_identifier__
)

/* harmony default export */ var graph_graph_component = (graph_component_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/header_ci_component.vue + 2 modules
var header_ci_component = __webpack_require__("./vue_shared/components/header_ci_component.vue");

// EXTERNAL MODULE: ./pipelines/event_hub.js
var event_hub = __webpack_require__("./pipelines/event_hub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/header_component.vue





/* harmony default export */ var header_component = ({
  name: 'PipelineHeaderSection',
  components: {
    ciHeader: header_ci_component["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      actions: this.getActions()
    };
  },


  computed: {
    status: function status() {
      return this.pipeline.details && this.pipeline.details.status;
    },
    shouldRenderContent: function shouldRenderContent() {
      return !this.isLoading && Object.keys(this.pipeline).length;
    }
  },

  watch: {
    pipeline: function pipeline() {
      this.actions = this.getActions();
    }
  },

  methods: {
    postAction: function postAction(action) {
      var index = this.actions.indexOf(action);

      this.$set(this.actions[index], 'isLoading', true);

      event_hub["a" /* default */].$emit('headerPostAction', action);
    },
    getActions: function getActions() {
      var actions = [];

      if (this.pipeline.retry_path) {
        actions.push({
          label: 'Retry',
          path: this.pipeline.retry_path,
          cssClass: 'js-retry-button btn btn-inverted-secondary',
          type: 'button',
          isLoading: false
        });
      }

      if (this.pipeline.cancel_path) {
        actions.push({
          label: 'Cancel running',
          path: this.pipeline.cancel_path,
          cssClass: 'js-btn-cancel-pipeline btn btn-danger',
          type: 'button',
          isLoading: false
        });
      }

      return actions;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2c6cf42","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/header_component.vue
var header_component_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pipeline-header-container"},[(_vm.shouldRenderContent)?_c('ci-header',{attrs:{"status":_vm.status,"item-name":"Pipeline","item-id":_vm.pipeline.id,"time":_vm.pipeline.created_at,"user":_vm.pipeline.user,"actions":_vm.actions},on:{"actionClicked":_vm.postAction}}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-default append-bottom-default",attrs:{"size":"2"}}):_vm._e()],1)}
var header_component_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/header_component.vue
/* script */


/* template */

/* template functional */
var header_component___vue_template_functional__ = false
/* styles */
var header_component___vue_styles__ = null
/* scopeId */
var header_component___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header_component___vue_module_identifier__ = null

var header_component_Component = Object(component_normalizer["a" /* default */])(
  header_component,
  header_component_render,
  header_component_staticRenderFns,
  header_component___vue_template_functional__,
  header_component___vue_styles__,
  header_component___vue_scopeId__,
  header_component___vue_module_identifier__
)

/* harmony default export */ var components_header_component = (header_component_Component.exports);

// CONCATENATED MODULE: ./pipelines/pipeline_details_bundle.js









vue_esm["a" /* default */].use(translate["a" /* default */]);

/* harmony default export */ var pipeline_details_bundle = __webpack_exports__["a"] = (function () {
  var dataset = document.querySelector('.js-pipeline-details-vue').dataset;

  var mediator = new pipeline_details_mediator({ endpoint: dataset.endpoint });

  mediator.fetchPipeline();

  // eslint-disable-next-line
  new vue_esm["a" /* default */]({
    el: '#js-pipeline-graph-vue',
    components: {
      pipelineGraph: graph_graph_component
    },
    data: function data() {
      return {
        mediator: mediator
      };
    },
    render: function render(createElement) {
      return createElement('pipeline-graph', {
        props: {
          isLoading: this.mediator.state.isLoading,
          pipeline: this.mediator.store.state.pipeline
        }
      });
    }
  });

  // eslint-disable-next-line
  new vue_esm["a" /* default */]({
    el: '#js-pipeline-header-vue',
    components: {
      pipelineHeader: components_header_component
    },
    data: function data() {
      return {
        mediator: mediator
      };
    },
    created: function created() {
      event_hub["a" /* default */].$on('headerPostAction', this.postAction);
    },
    beforeDestroy: function beforeDestroy() {
      event_hub["a" /* default */].$off('headerPostAction', this.postAction);
    },

    methods: {
      postAction: function postAction(action) {
        var _this = this;

        this.mediator.service.postAction(action.path).then(function () {
          return _this.mediator.refreshPipeline();
        }).catch(function () {
          return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while making the request.'));
        });
      }
    },
    render: function render(createElement) {
      return createElement('pipeline-header', {
        props: {
          isLoading: this.mediator.state.isLoading,
          pipeline: this.mediator.store.state.pipeline
        }
      });
    }
  });
});

/***/ }),

/***/ "./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue



/**
 * Renders CI Badge link with CI icon and status text based on
 * API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table - first column
 * - Jobs table - first column
 * - Pipeline show view - header
 * - Job show view - header
 * - MR widget
 */

/* harmony default export */ var ci_badge_link = ({
  components: {
    ciIcon: ci_icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    cssClass: function cssClass() {
      var className = this.status.group;
      return className ? 'ci-status ci-' + className : 'ci-status';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a93a9e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"href":_vm.status.details_path,"title":!_vm.showText ? _vm.status.text : ''}},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.showText)?[_vm._v("\n    "+_vm._s(_vm.status.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_badge_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_badge_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_badge_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 */
/* harmony default export */ var ci_icon = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36896c14","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{attrs:{"name":_vm.status.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/header_ci_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_badge_link.vue + 2 modules
var ci_badge_link = __webpack_require__("./vue_shared/components/ci_badge_link.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/time_ago_tooltip.vue + 2 modules
var time_ago_tooltip = __webpack_require__("./vue_shared/components/time_ago_tooltip.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/header_ci_component.vue







/**
 * Renders header component for job and pipeline page based on UI mockups
 *
 * Used in:
 * - job show page
 * - pipeline show page
 */
/* harmony default export */ var header_ci_component = ({
  components: {
    ciIconBadge: ci_badge_link["a" /* default */],
    loadingIcon: loading_icon["a" /* default */],
    timeagoTooltip: time_ago_tooltip["a" /* default */],
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    actions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    hasSidebarButton: {
      type: Boolean,
      required: false,
      default: false
    },
    shouldRenderTriggeredLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    userAvatarAltText: function userAvatarAltText() {
      return this.user.name + '\'s avatar';
    }
  },

  methods: {
    onClickAction: function onClickAction(action) {
      this.$emit('actionClicked', action);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c769665","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/header_ci_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-content-header ci-header-container"},[_c('section',{staticClass:"header-main-content"},[_c('ci-icon-badge',{attrs:{"status":_vm.status}}),_vm._v(" "),_c('strong',[_vm._v("\n        "+_vm._s(_vm.itemName)+" #"+_vm._s(_vm.itemId)+"\n      ")]),_vm._v(" "),(_vm.shouldRenderTriggeredLabel)?[_vm._v("\n        触发时间\n      ")]:[_vm._v("\n        创建时间\n      ")],_vm._v(" "),_c('timeago-tooltip',{attrs:{"time":_vm.time}}),_vm._v("\n\n      作者\n\n      "),(_vm.user)?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-user-link commit-committer-link",attrs:{"href":_vm.user.path,"title":_vm.user.email}},[_c('user-avatar-image',{attrs:{"img-src":_vm.user.avatar_url,"img-alt":_vm.userAvatarAltText,"tooltip-text":_vm.user.name,"img-size":24}}),_vm._v("\n\n          "+_vm._s(_vm.user.name)+"\n        ")],1)]:_vm._e()],2),_vm._v(" "),(_vm.actions.length)?_c('section',{staticClass:"header-action-buttons"},[_vm._l((_vm.actions),function(action,i){return [(action.type === 'link')?_c('a',{key:i,class:action.cssClass,attrs:{"href":action.path}},[_vm._v("\n          "+_vm._s(action.label)+"\n        ")]):(action.type === 'ujs-link')?_c('a',{key:i,class:action.cssClass,attrs:{"href":action.path,"data-method":"post","rel":"nofollow"}},[_vm._v("\n          "+_vm._s(action.label)+"\n        ")]):(action.type === 'button')?_c('button',{key:i,class:action.cssClass,attrs:{"disabled":action.isLoading,"type":"button"},on:{"click":function($event){_vm.onClickAction(action)}}},[_vm._v("\n          "+_vm._s(action.label)+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(action.isLoading),expression:"action.isLoading"}],staticClass:"fa fa-spin fa-spinner",attrs:{"aria-hidden":"true"}})]):_vm._e()]}),_vm._v(" "),(_vm.hasSidebarButton)?_c('button',{staticClass:"btn btn-default visible-xs-block\nvisible-sm-block sidebar-toggle-btn js-sidebar-build-toggle js-sidebar-build-toggle-header",attrs:{"type":"button","aria-label":"Toggle Sidebar","id":"toggleSidebar"}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true","aria-labelledby":"toggleSidebar"}})]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/header_ci_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  header_ci_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_header_ci_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/time_ago_tooltip.vue





/**
 * Port of ruby helper time_ago_with_tooltip
 */

/* harmony default export */ var time_ago_tooltip = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    time: {
      type: String,
      required: true
    },

    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },

    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202207e1","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"title":_vm.tooltipTitle(_vm.time),"data-placement":_vm.tooltipPlacement,"data-container":"body"}},[_vm._v("\n  "+_vm._s(_vm.timeFormated(_vm.time))+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/time_ago_tooltip.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  time_ago_tooltip,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_time_ago_tooltip = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["d" /* getTimeago */])();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["a" /* formatDate */])(time);
    }
  }
});

/***/ })

},["./pages/projects/pipelines/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.pipelines.show.182085840d8257074074.bundle.js